import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import VuexPersistence from 'vuex-persist'

const state = {
  isAuthenticated: localStorage.getItem('token') !== null,
  user: JSON.parse(localStorage.getItem('user')),
  saved: {
    pbns: [],
    buildOrders: []
  },
  viewData: [],
  languages: [],
  orders: [],
  linkOrders: [],
  linkOrder: {},
  clients: [],
  pbns: [],
  appliedFilters: {},
  pbn: {},
  pbnFilters: {},
  order: {},
  report: {},
  buildReport: [],
  userList: [],
  userRoles: ['fix', 'content', 'tech', 'links', 'build'],
  registrarList: [],
  viewFilters: {},
  hosts: [],
  maintenanceOrders: [],
  maintenanceOrder: {},
  task: {},
  tasks: [],
  pbnTemplates: [],
  pbnTemplate: {},
  passwordVisibility: false,
  userRoleList: [
    'content', 'fix', 'build', 'links', 'tech', 'operator', 'ppc', 'xero-view', 'xero-write'
  ],
  pbnTypes: [],
  ppcData: {},
  userBookmarks: [],
  dataStructures: {},
  projects: [],
  projectTasks: [],
  xeroData: {},
  xeroAccounts: [],
  xeroItems: [],
  xeroContacts: [],
  xeroCategories: [],
  brands: [],
  brand: {},
  affiliateCompanies: [],
  affiliateCompany: [],
  toplists: [],
  toplist: {}
}

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({saved: state.saved})
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  strict: true,
  plugins: [vuexLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js